export default __webpack_public_path__ + "static/side-nav-dont-6-65119a919438a92ddba89cdbc1f35fc797f109593c227415d1223df4cf5ffd54.png";